// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-24.use[1]!../../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-24.use[2]!../../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-24.use[3]!../../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-24.use[4]!./_fa-font-face.scss");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("f0f2c488", content, true, {"sourceMap":false,"shadowMode":false});